'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { MailRound, LocationRound, BuildingRound } from '@/public/images/icons/icons';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export default function ContactUs() {
    const t = useTranslations('Contact');

    return (
        <motion.section
            aria-labelledby="contact-heading"
            className="w-full bg-white py-16 sm:py-24 px-6 sm:px-10 lg:px-16"
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={fadeInUp}
        >
            <div className="max-w-8xl mx-auto space-y-10">
                <div className="space-y-3">
                    <span className="text-xs sm:text-sm font-bold tracking-widest color-primary uppercase">
                        {t('subtitle')}
                    </span>
                    <h2 id="contact-heading" className="text-3xl sm:text-5xl font-extrabold text-gray-900 tracking-tight">
                        {t('title')}
                    </h2>
                    <p className="text-sm sm:text-base text-gray-500 font-normal leading-relaxed">
                        {t('description')}
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <span
                        className="bg-[#F8FAFC] hover:bg-[#F1F5F9] rounded-2xl p-6 border border-slate-100 flex items-center gap-4 transition-all duration-200 group"
                    >
                        <div className="w-12 h-12 rounded-full bg-blue-50/80 group-hover:bg-blue-100/80 flex items-center justify-center shrink-0 transition-colors">
                            <MailRound width={40} height={40} className="shrink-0 globe-spin" />
                        </div>
                        <div className="space-y-0.5 overflow-hidden">
                            <span className="text-[10px] sm:text-xs font-bold color-primary uppercase tracking-wider block">
                                {t('general')}
                            </span>
                            <p className="text-sm sm:text-base font-bold text-gray-900 group-hover:color-primary transition-colors flex items-center gap-1.5 truncate">
                                <span>info@mpay.al</span>
                            </p>
                        </div>
                    </span>
                    <span
                        className="bg-[#F8FAFC] hover:bg-[#F1F5F9] rounded-2xl p-6 border border-slate-100 flex items-center gap-4 transition-all duration-200 group"
                    >
                        <div className="w-12 h-12 rounded-full bg-blue-50/80 group-hover:bg-blue-100/80 flex items-center justify-center shrink-0 transition-colors">
                            <LocationRound width={40} height={40} className="shrink-0 globe-spin" />
                        </div>
                        <div className="space-y-0.5 overflow-hidden">
                            <span className="text-[10px] sm:text-xs font-bold color-primary uppercase tracking-wider block">
                                {t('address')}
                            </span>
                            <p className="text-sm sm:text-base font-bold text-gray-900 group-hover:color-primary transition-colors flex items-center gap-1.5 truncate">
                                <span>{t('address_locale')}</span>
                            </p>
                        </div>
                    </span>
                    <a
                        href={"https://mpay.al"}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                        className="bg-[#F8FAFC] hover:bg-[#F1F5F9] rounded-2xl p-6 border border-slate-100 flex items-center gap-4 transition-all duration-200 group"
                    >
                        <div className="w-12 h-12 rounded-full bg-blue-50/80 group-hover:bg-blue-100/80 flex items-center justify-center shrink-0 transition-colors">
                            <BuildingRound width={40} height={40} className="shrink-0 globe-spin" />
                        </div>
                        <div className="space-y-0.5 overflow-hidden">
                            <span className="text-[10px] sm:text-xs font-bold color-primary uppercase tracking-wider block">
                                {t('institutional')}
                            </span>
                            <p className="text-sm sm:text-base font-bold text-gray-900 group-hover:color-primary transition-colors flex items-center gap-1.5 truncate">
                                <span>{t('visit')} mpay.al</span>
                                <span className="inline-block transition-transform duration-200 group-hover:translate-x-1">
                                    →
                                </span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </motion.section>
    );
}